import { render, staticRenderFns } from "./ShiftHeader.vue?vue&type=template&id=94eaea96&scoped=true"
import script from "./ShiftHeader.vue?vue&type=script&lang=js"
export * from "./ShiftHeader.vue?vue&type=script&lang=js"
import style0 from "./ShiftHeader.vue?vue&type=style&index=0&id=94eaea96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94eaea96",
  null
  
)

export default component.exports